import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingWhatsApp = () => {
    return (
        <a
            href="https://wa.me/917982747220?text=Hi, I am interested in your products!"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-50 bg-green-500 text-white p-4 rounded-full shadow-2xl hover:bg-green-600 transition duration-300 transform hover:scale-110"
        >
            <FaWhatsapp size={32} />
        </a>
    );
};

export default FloatingWhatsApp;